import { Game, Types } from 'phaser';
import StartScreen from './scenes/startScreen'
import preloader from './scenes/preloader'
import Tutorial1 from './scenes/tutorial_1'
import Tutorial2 from './scenes/tutorial_2'
import Tutorial3 from './scenes/tutorial_3'
import Tutorial4 from './scenes/tutorial_4'


const gameConfig: Types.Core.GameConfig = {
	title: 'Phaser game tutorial',
  type: Phaser.WEBGL,
  parent: 'game',
  backgroundColor: '#351f1b',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 1280,
    height: 720,
  },
  physics: {
    default: 'arcade',
    arcade: {
      // debug: true,
      gravity: { x: 0, y: 1000 }
    },
  },
  render: {
    antialiasGL: false,
    pixelArt: true,
  },
  callbacks: {
    postBoot: () => {
    },
  },
  canvasStyle: 'display: block;',
  autoFocus: true,
  audio: {
    disableWebAudio: false,
  },
  scene: [preloader, StartScreen, Tutorial1, Tutorial2, Tutorial3, Tutorial4],
};

  window.game = new Game(gameConfig);
  